export interface BatchBibliographyCollectionExportRequest {
  branchCode: string
  shelfType: string
  acceptDateFrom: string
  acceptDateTo: string
}

export function BatchBibliographyCollectionExportRequestToJSON(
  value: BatchBibliographyCollectionExportRequest
): any {
  return {
    branch_code: value.branchCode,
    shelf_type: value.shelfType,
    accept_date_from: value.acceptDateFrom,
    accept_date_to: value.acceptDateTo
  }
}
